export const sharedRoutes = {
  FIVETRAN_CONNECTION: "/fivetran-connection",
}
